import React from "react";
import { DeleteIcon } from "../../icons";
import { RadixCheckbox } from "../../primitives/RadixCheckbox";
import { ToppingImage } from "../../primitives/ToppingImage";
import { LeftPortionIcon, RightPortionIcon, WholePortionIcon } from "./PortionIcons";
import { formatter } from "../../utility/formatter";
export var IncludedModifierTagButton = function (_a) {
    var modifierId = _a.modifierId, label = _a.label, choice = _a.choice, excluded = _a.excluded, showHalf = _a.showHalf, showDouble = _a.showDouble, onExclude = _a.onExclude, onReAdd = _a.onReAdd, onSetFirstHalf = _a.onSetFirstHalf, onSetSecondHalf = _a.onSetSecondHalf, onSetWhole = _a.onSetWhole, onSetExtra = _a.onSetExtra, onSetNormal = _a.onSetNormal;
    var usesWholeToggle = !showHalf;
    var handleExcludedToggle = function () {
        onReAdd(modifierId);
    };
    var handleExcludedKeyDown = function (event) {
        if (!usesWholeToggle) {
            return;
        }
        if (event.key !== "Enter" && event.key !== " ") {
            return;
        }
        event.preventDefault();
        handleExcludedToggle();
    };
    if (excluded) {
        return (React.createElement("div", { className: "item-customization-modifier-option item-customization-modifier-option--removed", onClick: usesWholeToggle ? handleExcludedToggle : undefined, onKeyDown: usesWholeToggle ? handleExcludedKeyDown : undefined, role: usesWholeToggle ? "button" : undefined, tabIndex: usesWholeToggle ? 0 : undefined, "aria-pressed": usesWholeToggle ? false : undefined },
            React.createElement(ToppingImage, { label: label }),
            React.createElement("div", { className: "item-customization-modifier-option-content" },
                React.createElement("div", { className: "item-customization-radio-option-title-row" },
                    React.createElement("span", null, formatter.removeTrailingAsterisk(label))),
                React.createElement("button", { type: "button", className: "item-customization-chip", onClick: function () { return onReAdd(modifierId); } }, "Add back"))));
    }
    var isSelected = ((choice === null || choice === void 0 ? void 0 : choice.quantity) || 0) > 0;
    var isFirstHalf = isSelected && choice.portion === "first-half";
    var isSecondHalf = isSelected && choice.portion === "second-half";
    var isWhole = isSelected && choice.portion === "whole";
    var isExtra = isSelected && choice.size === "extra";
    var toggleSelection = function () {
        if (isWhole) {
            onExclude(modifierId);
            return;
        }
        onSetWhole(modifierId);
    };
    var handleCardKeyDown = function (event) {
        if (!usesWholeToggle) {
            return;
        }
        if (event.key !== "Enter" && event.key !== " ") {
            return;
        }
        event.preventDefault();
        toggleSelection();
    };
    var stopTogglePropagation = function (event) {
        event.stopPropagation();
    };
    var toggleExtra = function (checked) {
        if (!isSelected) {
            return;
        }
        if (checked) {
            onSetExtra(modifierId);
            return;
        }
        onSetNormal(modifierId);
    };
    return (React.createElement("div", { className: "item-customization-modifier-option item-customization-modifier-option--selected", onClick: usesWholeToggle ? toggleSelection : undefined, onKeyDown: usesWholeToggle ? handleCardKeyDown : undefined, role: usesWholeToggle ? "button" : undefined, tabIndex: usesWholeToggle ? 0 : undefined, "aria-pressed": usesWholeToggle ? isWhole : undefined },
        React.createElement(ToppingImage, { label: label }),
        React.createElement("div", { className: "item-customization-modifier-option-content" },
            React.createElement("div", { className: "item-customization-radio-option-title-row" },
                React.createElement("span", null, isExtra ? "Extra ".concat(formatter.removeTrailingAsterisk(label)) : formatter.removeTrailingAsterisk(label)),
                usesWholeToggle ? (React.createElement("div", { onClick: stopTogglePropagation, onKeyDown: stopTogglePropagation },
                    React.createElement(RadixCheckbox, { checked: isWhole, onCheckedChange: function () {
                            toggleSelection();
                        }, className: "item-customization-addon-checkbox item-customization-portion-checkbox", label: React.createElement("span", { className: "sr-only" },
                            "Include ",
                            label), ariaDescription: "Toggle ".concat(label) }))) : null),
            React.createElement("div", { className: "item-customization-topping-controls" },
                showHalf ? (React.createElement("div", { className: "item-customization-topping-control-group item-customization-topping-control-group--portion", "aria-label": "Included portion controls" },
                    React.createElement("button", { type: "button", className: ["item-customization-chip", "item-customization-chip--portion", isFirstHalf ? "item-customization-chip--active" : ""].filter(Boolean).join(" "), onClick: function () { return onSetFirstHalf(modifierId); } },
                        React.createElement(LeftPortionIcon, null)),
                    React.createElement("button", { type: "button", className: ["item-customization-chip", "item-customization-chip--portion", isWhole ? "item-customization-chip--active" : ""].filter(Boolean).join(" "), onClick: function () { return onSetWhole(modifierId); } },
                        React.createElement(WholePortionIcon, null)),
                    React.createElement("button", { type: "button", className: ["item-customization-chip", "item-customization-chip--portion", isSecondHalf ? "item-customization-chip--active" : ""].filter(Boolean).join(" "), onClick: function () { return onSetSecondHalf(modifierId); } },
                        React.createElement(RightPortionIcon, null)))) : null,
                showDouble ? (React.createElement("div", { onClick: stopTogglePropagation, onKeyDown: stopTogglePropagation },
                    React.createElement(RadixCheckbox, { checked: isExtra, onCheckedChange: toggleExtra, disabled: !isSelected, className: ["item-customization-extra-toggle", isExtra ? "item-customization-extra-toggle--active" : "", !isSelected ? "item-customization-extra-toggle--disabled" : ""].filter(Boolean).join(" "), inputClassName: "item-customization-extra-toggle-input", labelClassName: "item-customization-extra-toggle-label", label: React.createElement(React.Fragment, null,
                            React.createElement("span", { className: "item-customization-extra-toggle-knob", "aria-hidden": "true" }),
                            React.createElement("span", null, "Extra")), ariaDescription: "Toggle extra for ".concat(label) }))) : null,
                showHalf ? (React.createElement("div", { className: "item-customization-topping-control-group item-customization-topping-control-group--danger", "aria-label": "Included remove control" },
                    React.createElement("button", { type: "button", className: "item-customization-chip item-customization-chip--danger", onClick: function () { return onExclude(modifierId); } },
                        React.createElement("span", { className: "item-customization-remove-icon", "aria-hidden": "true" },
                            React.createElement(DeleteIcon, null)),
                        "Remove"))) : null))));
};
